import { render, staticRenderFns } from "./LeagueBetgame.vue?vue&type=template&id=0c2b3a4e&scoped=true"
import script from "./LeagueBetgame.vue?vue&type=script&lang=js"
export * from "./LeagueBetgame.vue?vue&type=script&lang=js"
import style0 from "./LeagueBetgame.vue?vue&type=style&index=0&id=0c2b3a4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b3a4e",
  null
  
)

export default component.exports